import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevLayoutComponent } from 'app/modules/dev/dev-layout.component';
import { AuthGuard } from 'core/guards/auth.guard';
import { DevGuard } from 'core/guards/dev.guard';
import { PageNotFoundComponent } from 'project/pages/page-not-found/page-not-found.component';
import { AssignedProjectsResolver, NotSawChangelogResolver } from 'project/project-routing.module';
import { DevStateResolver } from './dev-resolvers';

export { DevStateResolver } from './dev-resolvers';

const routes: Routes = [
  {
    path: '',
    component: DevLayoutComponent,
    canActivate: [AuthGuard, DevGuard],
    canActivateChild: [AuthGuard, DevGuard],
    resolve: {
      changelog: NotSawChangelogResolver,
      projects: AssignedProjectsResolver,
      state: DevStateResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'couriers',
        pathMatch: 'full',
      },
      {
        path: 'couriers',
        loadChildren: () => import('./modules/courier/courier.module').then(m => m.CourierModule),
      },
      {
        path: 'documents',
        loadChildren: () => import('./modules/document/document.module').then(m => m.DocumentModule),
      },
      {
        path: '**',
        component: PageNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DevRoutingModule {
}
